//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		items: { type: Number, default: 3 },
		radio: { type: Boolean, default: false },
		type: { type: String, default: "avatar" },
		animation: { type: String, default: "wave" },
		caption: { type: Boolean, default: false },
		icon: { type: Boolean, default: false },
	}
}
